/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type ServiceCancellationHubReturnQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type ServiceCancellationHubReturnQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
      capabilities: {
        __typename?: 'ServiceBreakLocationCapabilities'
        nonAd: boolean
      }
    }>
  }
}

export const ServiceCancellationHubReturnDocument = gql`
    query serviceCancellationHubReturn($regionId: ID!) {
  serviceBreakLocations(
    input: {regionId: $regionId, filters: {states: [ACTIVE], types: [HUB]}}
  ) {
    serviceBreakLocations {
      id
      name
      capabilities {
        nonAd
      }
    }
  }
}
    `

/**
 * __useServiceCancellationHubReturnQuery__
 *
 * To run a query within a React component, call `useServiceCancellationHubReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCancellationHubReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCancellationHubReturnQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useServiceCancellationHubReturnQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  > &
    (
      | {
          variables: ServiceCancellationHubReturnQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >(ServiceCancellationHubReturnDocument, options)
}
export function useServiceCancellationHubReturnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >(ServiceCancellationHubReturnDocument, options)
}
// @ts-ignore
export function useServiceCancellationHubReturnSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceCancellationHubReturnQuery,
  ServiceCancellationHubReturnQueryVariables
>
export function useServiceCancellationHubReturnSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceCancellationHubReturnQuery,
        ServiceCancellationHubReturnQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceCancellationHubReturnQuery | undefined,
  ServiceCancellationHubReturnQueryVariables
>
export function useServiceCancellationHubReturnSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceCancellationHubReturnQuery,
        ServiceCancellationHubReturnQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >(ServiceCancellationHubReturnDocument, options)
}
export type ServiceCancellationHubReturnQueryHookResult = ReturnType<
  typeof useServiceCancellationHubReturnQuery
>
export type ServiceCancellationHubReturnLazyQueryHookResult = ReturnType<
  typeof useServiceCancellationHubReturnLazyQuery
>
export type ServiceCancellationHubReturnSuspenseQueryHookResult = ReturnType<
  typeof useServiceCancellationHubReturnSuspenseQuery
>
export type ServiceCancellationHubReturnQueryResult = Apollo.QueryResult<
  ServiceCancellationHubReturnQuery,
  ServiceCancellationHubReturnQueryVariables
>
